import "./styles/theme.scss";
import "@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "@fortawesome/fontawesome-free/css/solid.min.css";
import {createTextComponent, mount, SECTION} from "@juis/components";
import {Router} from "@juis/router";
import {AppShell} from "./AppShell.js";
import {HAS_NAVBAR_FIXED_TOP, SECTION_CLASS} from "./cssClasses.js";
import {session} from "./session.js";

const router = new Router({
    fallbackUrl: "/",
    loading: () => createTextComponent("Loading…", SECTION, [SECTION_CLASS]),
    notFound: () => createTextComponent("Page not found", SECTION, [SECTION_CLASS]),
    error: error => createTextComponent(`Something went wrong: ${String(error)}`, SECTION, [SECTION_CLASS])
});

router.addRoute("/", () =>
    import("./views/LibraryView.js").then(module => module.createLibraryView()), {alwaysReload: true});
router.addRoute("/login", () =>
    import("./views/LoginView.js").then(module => module.createLoginView()));
router.addRoute("/register", () =>
    import("./views/RegisterView.js").then(module => module.createRegisterView()));
router.addRoute("/books/:bookId", context =>
    import("./views/PlayerView.js").then(module => module.createPlayerView(context)), {alwaysReload: true});
router.addRoute("/groups", () =>
    import("./views/GroupsView.js").then(module => module.createGroupsView()), {alwaysReload: true});
router.addRoute("/groups/:groupId", context =>
    import("./views/GroupDetailView.js").then(module => module.createGroupDetailView(context)), {alwaysReload: true});
router.addRoute("/settings", () =>
    import("./views/SettingsView.js").then(module => module.createSettingsView()), {alwaysReload: true});
router.addRoute("/join", context =>
    import("./views/JoinView.js").then(module => module.createJoinView(context)), {alwaysReload: true});

document.body.classList.add(HAS_NAVBAR_FIXED_TOP);
mount(document.body, new AppShell(router));
void session.load().then(() => router.start());
